import React from 'react';

type Props = {
  alertTitle?: string,
  alertMessage: string,
  alertType: string,
  noInline?: boolean,
  dataId?: string,
};

function Alert(props: Props) {
  const { alertTitle, alertMessage, alertType, noInline, dataId } = props;
  const alertInline = noInline ? 'alert' : 'alert-inline';
  const alertStyle = `${alertInline} ${alertInline}--${alertType}`;
  return (
    <div className={alertStyle}>
      {/* alert message */}
      <span
        className="alert__message"
        data-automation-id={dataId && `${dataId}AlertMessage`}
      >
        {alertTitle && (
          <span
            className={`${alertInline}__title`}
            data-automation-id={dataId && `${dataId}AlertTitle`}
          >
            {alertTitle}
          </span>
        )}
        {alertMessage}
      </span>
    </div>
  );
}

Alert.defaultProps = {
  alertTitle: null,
  noInline: false,
  dataId: null,
};

export default Alert;
